<template>
    <div>
      <!-- modal -->
      <b-modal id="lawMatterTypeSubFolderFormModal" ref="lawMatterTypeSubFolderFormModal" centered size="lg" no-close-on-backdrop title="Alt Klasör Bilgisi" :cancel-title="$t('others.cancel_title')"
        :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
          <b-row>
            <b-col class="col-lg-12">
              <b-form>
                  <label for="law-matter-type-sub-folder-type-input">İşlem Tipi</label>
                  <b-form-group>
                    <b-form-select id="law-matter-type-sub-folder-type-input" size="sm" v-model="lawMatterTypeId" value-field="id" text-field="name" :options="lawMatterTypeOption"/>
                  </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-lg-8">
              <b-form>
                  <label for="law-matter-type-sub-folder-name-input">Alt Klasör Adı</label>
                  <b-form-group>
                    <validation-provider #default="{ errors }" name="Alt Klasör Adı" rules="required">
                      <b-form-input id="law-matter-type-sub-folder-name-input" size="sm" v-model="name" maxlength="100" :state="errors.length > 0 ? false:null"/>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
              </b-form>
            </b-col>
            <b-col class="col-lg-4">
              <b-form>
                  <label for="law-matter-type-sub-folder-order-input">Sıra</label>
                  <b-form-group>
                    <b-form-input id="law-matter-type-sub-folder-order-input" type="number" size="sm" v-model="orderNo"/>
                  </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>
  export default {
    props: {
      getLawMatterTypeSubFolderList: {type: Function},
    },
    data() {
      return {
        id: 0,
        lawMatterTypeId: 0,
        name: '',
        orderNo: 0,
        lawMatterTypeOption: [],
      }
    },
    methods: {
      showInfo(id) {
        this.$refs['lawMatterTypeSubFolderFormModal'].show()
        this.id = id
        this.lawMatterTypeId = 0
        this.name = ''
        this.orderNo = 0
        this.loadLawMatterTypeList()
        if (id > 0) {
          const data = {id: this.id}
          const controller = {name : 'LawMatterTypeSubFolder'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
              if(response.data.resultStatus == true){
                  this.lawMatterTypeId = response.data.lawMatterTypeSubFolder.lawMatterTypeId
                  this.name = response.data.lawMatterTypeSubFolder.name
                  this.orderNo = response.data.lawMatterTypeSubFolder.orderNo
              } else {
                  this.$bvModal.hide('lawMatterTypeSubFolderFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }
          })
        }
      },
      loadLawMatterTypeList() {
        const controller = {name: 'LawMatterType', actionName: 'GetLawMatterTypeList'}
        const payload = {controller: controller}
        this.$store.dispatch('moduleAuth/customServiceGet', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.lawMatterTypeOption = response.data.lawMatterTypeList
            this.lawMatterTypeOption.splice(0, 0, this.$nullSelected())
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      },
      addOrUpdate() {
        if (!this.lawMatterTypeId || this.lawMatterTypeId == 0) {
          this.$WarningAlert('Lütfen işlem tipi seçiniz.')
          return
        }
        const data = {id: this.id, lawMatterTypeId: this.lawMatterTypeId, name: this.name, orderNo: parseInt(this.orderNo) || 0}
        const controller = {name : 'LawMatterTypeSubFolder'}
        const payload = {data: data, controller: controller}
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$store.dispatch('moduleAuth/save',payload).then((response) => {
              if(response.data.resultStatus == true){
                  this.$bvModal.hide('lawMatterTypeSubFolderFormModal')
                  this.getLawMatterTypeSubFolderList()
                  this.$SaveAlert()
              } else {
                  this.$WarningAlert(response.data.resultMessage)
              }
            })
          }
        })
      },
    }
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  </style>
